import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { observer } from 'mobx-react-lite';
import Skeleton from '../../../../skeleton';
import { IconArrowRightWide } from '../../../../../icons/arrow-right-wide';
import { IconButton } from '../../../../../icon/button/icon-button';
import { CardTitle } from '../../../../../card/title/card-title';
import { ValueDescription } from '../../../../../card/value-description/value-description';

export const SkeletonDashboardCardsInvestedValue: React.FC = observer(() => {
    const { t } = useTranslation();

    return (
        <div className="relative flex h-full min-h-[37.6rem] flex-col justify-between overflow-hidden rounded-large bg-body p-[1.6rem] shadow-strong lg:p-[2.2rem]">
            <CardTitle
                title={t('layout.statisticsCard.investedValue.title')}
                actions={
                    <IconButton
                        icon={<IconArrowRightWide />}
                        variant={'default'}
                        variation={'outlined'}
                        size={'small'}
                    />
                }
            />
            <div className="gap-xsmall">
                <>
                    <ValueDescription
                        padding={'none'}
                        value={<Skeleton height={2} />}
                        description={<Skeleton height={1.3} />}
                    />

                    <br />

                    <div className="text-medium leading-vlarge">
                        {t('layout.statisticsCard.investedValue.investmentPeriod')}
                    </div>

                    <div className="text-medium leading-vlarge font-bold">
                        <Skeleton height={1.4} />
                    </div>

                    <br />

                    <div className="text-medium leading-vlarge">
                        {t('layout.statisticsCard.investedValue.monthlyAverage')}
                    </div>
                    <div className="text-medium leading-vlarge font-bold">
                        <Skeleton height={1.4} />
                    </div>
                </>
            </div>
        </div>
    );
});
